import Vue from 'vue'

// 精度转换
Vue.filter('precise', (value, digits = 2, showZero = false) => {
  if (
    value === '' ||
    value === undefined ||
    value === null ||
    (value === 0 && !showZero)
  ) {
    return '--'
  }
  return typeof value === 'number' ? Number(value).toFixed(digits) : value
})
